import ScrollSpy from 'bootstrap/js/src/scrollspy';
import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import 'protons';
import './_portfolio.scss';
import './_portfolio.twig';

export const name = 'portfolio';

export const defaults = {};

export function disable() {}

const ACTIVE_CLASSNAME = 'portfolio__letter--active';
const controller = new ScrollMagic.Controller();

export function enable(context) {
  $('.portfolio', context).each((index, portfolio) => {
    const $letters = $('.portfolio__letter', portfolio);

    const setActiveLetter = () => {
      const activeLetter = $('.nav-link.active', context).data('active');

      $letters
        .removeClass(ACTIVE_CLASSNAME)
        .filter((i, el) => $(el).data('active') === activeLetter)
        .addClass(ACTIVE_CLASSNAME);
    };

    // eslint-disable-next-line no-new
    new ScrollSpy(document.body, {
      target: '#portfolio-navbar',
      offset: 80,
    });

    $(window).on('activate.bs.scrollspy', setActiveLetter);
    setActiveLetter();

    const scene = new ScrollMagic.Scene({
      triggerElement: portfolio,
      triggerHook: 'onLeave',
      offset: 100,
      duration: () => portfolio.offsetHeight - window.innerHeight - 100,
    });

    scene
      .addTo(controller)
      .on('enter leave start end', (e) => {
        console.log(e.type);
      })
      .setClassToggle('.portfolio__letters', 'portfolio__letters--sticky');
  });
}

export default enable;
